export enum LayoutClassesEnum {
  Desktop = 'layout-desktop',
  Tablet = 'layout-tablet',
  Mobile = 'layout-mobile',
}

export const LayoutClassesEnumNames = {
  [LayoutClassesEnum.Desktop]: 'layout-desktop',
  [LayoutClassesEnum.Tablet]: 'layout-tablet',
  [LayoutClassesEnum.Mobile]: 'layout-mobile',
};
